import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DTFHomepageService } from "./dtfhomepage.service";
import { Banner } from "../../shared/models/banner";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';

import { CookiesPopupComponent } from "../cookiesPopup/cookiesPopupDialog.component";
import { MatDialog } from "@angular/material/dialog";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { HeaderComponent } from "../../furniture/header.component";
import { FooterComponent } from "../../furniture/footer.component";
import { PasswordResetConfirmComponent } from "../passwordresetconfirm/passwordresetconfirm.component";
//import { BehaviorSubject } from "rxjs";
// import { ClassesUtil } from '../../utils/classes-util';
// import { WindowRef } from '../../utils/window';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationConfirmComponent } from "../registrationConfirm/registrationConfirm.component";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";
import { ViewChild, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: "div.dtf-homepage",
    imports: [
        SharedTranslateModule, PasswordResetConfirmComponent, RegistrationConfirmComponent,SessionTimeoutComponent,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, NgbCarouselModule, MatSortModule
    ],
    templateUrl: "./dtfhomepage.component.html",
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class DTFHomeComponent implements OnInit {
  router: Router;
  public alerts: Banner;
  public alertsCopy: Banner;
  toggleOpen: any;
  dbData: any;
  displayStatic: boolean = false;
  flag: boolean = true;
  dbCopy: any;
  position1 = 'top';
  position2 = 'mid';
  position3 = 'bot';
  myInterval = 10000; // Carousel Rotate Speed
  passwordResetFlag = false;
  RegistrationConfirmFlag=false;
  RegistrationPopup = false;
  showVideo = false;
  usUrl: string;
  caUrl: string;
  fullGuestPayUrl: string;
  videoredirect = '';
  showPopup='';
  // Current = true;
  // DTPAY = false;
  divStyle = '';

  public sliders: Array<Banner> = [];
  repayURL = 'https://dtf.repay.io/ebpp/';
  @ViewChild('swipeTrack', { static: false }) swipeTrack!: ElementRef;
  @ViewChild('heroVideo') videos!: QueryList<ElementRef<HTMLVideoElement>>;
  baseRedirect = '';
  language = '';
  isFrench = false;
  currentIndex = 0;

  cards = [
    { 
      title: 'Finance and Lease Solutions', 
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    },
    { 
      title: 'Insurance', 
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    },
    { 
      title: 'Connected Insurance',  
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    },
    { 
      title: 'Connected Insurance',  
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    },
    { 
      title: 'Connected Insurance',  
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    },
    { 
      title: 'Connected Insurance',  
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    },
    { 
      title: 'Connected Insurance',  
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    },
    { 
      title: 'Connected Insurance',  
      image: 'static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg', 
      route: '{{this.baseRedirect}}/home/financeleasesolutions' 
    }
  ];

  constructor(
    router: Router,
    public translate: TranslateService,
    public dtfhomepageService: DTFHomepageService,
    private _window: WindowRef,
    public dialog: MatDialog
  ) {
    this.router = router;
    // this.addSlides();
    this.dbData = false;
    this.dbCopy = '';
    this.repayURL = (this._window.nativeWindow as any).mbfs.repayURL;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.fullGuestPayUrl = this.usUrl + '/home/guestpay';
    this.getAlerts();
}
  ngOnInit() {
    this.langInit()
    const disableGA  = (this._window.nativeWindow as any).mbfs.disableGA;
    if(localStorage.getItem('enableGA')){
      this.showPopup = localStorage.getItem('enableGA');
  }
    const passwordreset = (this._window.nativeWindow as any).mbfs.passwordreset;
    if(passwordreset !=""){
      this.checkPassword();
    }
    const registrationConfirm = (this._window.nativeWindow as any).mbfs.registrationConfirm;
    if(registrationConfirm !=""){
      this.checkRegistrationConfirm();
    }
    
    if(disableGA ===""){
      if(passwordreset ===""){
        if(registrationConfirm ===""){
          if(this.showPopup!='yes'){
            this.openDialog();
          }
         
        }
      }
    }
    const registrationOpen = (this._window.nativeWindow as any).mbfs.registrationPopup;
    if(registrationOpen !=""){
      this.checkRegistrationPopup();
    }

    this.divStyle = '/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg';
  }

    ngAfterViewInit() {
    const video = this.videos.first?.nativeElement;
    if (video) {
      video.muted = true;
      video.play().catch(() => {
        console.log('Autoplay prevented');
      });
    }
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  onSlide(event: NgbSlideEvent) {
  // When leaving first slide
  if (event.prev === 'ngb-slide-0') {
    const video = this.videos.first?.nativeElement;
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }
}

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.baseRedirect = this.usUrl + '/ca/en/';
    } else if (this.language === 'fr-CA') {
        this.baseRedirect = this.usUrl + '/ca/fr/';
    } else {
        this.baseRedirect = this.usUrl;
    }
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
  }



slideLeft() {
  const track = this.swipeTrack.nativeElement as HTMLElement;
  const firstCard = track.querySelector('.image-swipe-card') as HTMLElement;

  if (!firstCard) return;

  // Scroll so the FIRST card is centered
  const scrollLeft =
    firstCard.offsetLeft - (track.clientWidth / 2) + (firstCard.offsetWidth / 2);

  track.scrollTo({
    left: Math.max(0, scrollLeft),
    behavior: 'smooth'
  });
}

slideRight() {
  const track = this.swipeTrack.nativeElement as HTMLElement;
  const cards = track.querySelectorAll('.image-swipe-card') as NodeListOf<HTMLElement>;
  const lastCard = cards[cards.length - 1];

  if (!lastCard) return;

  // Scroll so the LAST card is centered
  const scrollLeft =
    lastCard.offsetLeft - (track.clientWidth / 2) + (lastCard.offsetWidth / 2);

  track.scrollTo({
    left: Math.min(track.scrollWidth, scrollLeft),
    behavior: 'smooth'
  });
}


  goTo(route: string) {
    this.router.navigate([route]);
  }

  getAlerts() {
    this.dtfhomepageService.getAlerts().subscribe((res) => {
        for (var i = 0; i < res.length; i++) {
          // if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
          //   this.alerts = res[i];
          //   this.dbData = true;
          // }
          if (res[i].bannerType === 'Banner' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
            this.sliders.push(res[i]);
          }
          // if (res[i].btnUrl === "DTPAY") {
          //   this.DTPAY = true;
          //   this.Current = false;
          // }
        }
        if (!this.sliders?.length) {this.displayStatic = true;} //Turns on Static page if no banners are pulled      
      });
  }

 isBlank(str) {
    return (!str || /^\s*$/.test(str));
}

checkPassword(){
  this.passwordResetFlag=true;
}

checkRegistrationConfirm(){
  this.RegistrationConfirmFlag=true;
}

checkRegistrationPopup(){
  this.RegistrationPopup=true;
}

openDialog() {
  this.dialog.open(CookiesPopupComponent, {
    maxWidth: '100%',
    width: '100%',
    disableClose: true
});
}
  clickvideo(redirect: string){
   
    sessionStorage.removeItem('videoRedirect');
    this.showVideo = false;

    if(redirect === "mainnav"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-MainNavigationOverview7-25-24_1.mp4";
    }
    sessionStorage.setItem('videoRedirect', this.videoredirect);

    let azURL =  this.usUrl + '/home/video';

    setTimeout(() => {
      window.open(azURL, '_blank', 'width=1200, height=900');
    }, 500);  //1s
  }

}
